<script setup lang="ts">
import { X } from 'lucide-vue-next';

defineProps({
  width: {
    type: String,
    required: false,
  },
  height: {
    type: String,
    required: false,
  },
});

const emits = defineEmits(['close']);

function closeModal() {
  emits('close');
}
</script>

<template>
  <dialog class="youbook-modal yb-preset" open>
    <div class="modal-content" :style="{ width, height }">
      <div class="modal-header">
        <slot name="header">
          <h3 class="modal-title">
            <slot name="title" />
          </h3>
        </slot>
        <div class="modal-header-close" @click="closeModal">
          <X />
        </div>
      </div>
      <div class="modal-body">
        <slot />
      </div>
      <div class="modal-footer">
        <slot name="footer" />
      </div>
    </div>
  </dialog>
</template>

<style lang="css">
dialog.youbook-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  border: 0;

  .modal-content {
    position: absolute;
    max-height: 90dvh;
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: 10px;
    overflow-y: auto;
  }

  .modal-body,
  .modal-header,
  .modal-footer {
    padding: 1rem;
  }

  .modal-body:empty,
  .modal-header:empty,
  .modal-footer:empty {
    display: none;
  }

  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .modal-header-close {
      display: flex;
      justify-content: end;
      width: fit-content;
      margin-left: auto;
      cursor: pointer;
    }

    .modal-title {
      font-weight: 700;
      font-size: 1.4rem;
    }
  }

  .modal-body {
    overflow: auto;
    flex: 1;
    min-height: 460px;
    display: flex;
    flex-direction: column;
    scrollbar-width: thin;
    scrollbar-color: #9ca3af transparent;
  }

  .modal-footer {
    border-top: 1px solid rgb(200, 200, 200);

    .spacer {
      display: flex;
      justify-content: space-between;
    }

    button {
      all: unset;
      background: var(--yb-color-primary);
      color: white;
      padding: 0.8rem 1rem;
      border-radius: 10px;
      font-weight: 600;
      line-height: 1;
      cursor: pointer;
    }
  }
}
</style>
